

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import SiteName from "~/components/SiteName.vue";
import NavLinks from "~/components/NavLinks.vue";
import LinkExternal from "~/components/LinkExternal.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        SiteName,
        NavLinks,
        LinkExternal
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        year (): number {
            return new Date().getFullYear();
        }
    }

    // -------------------------------------------------------------------------
});

